import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { reducer as formReducer } from "redux-form";
import contentReducer from "./reducers/contentReducer.js";
import trendingReducer from "./reducers/trendingReducer";
import searchReducer from "./reducers/searchReducer";
import shareReducer from "./reducers/shareReducer";

const create = initData => {
  const { referralCode, widget } = initData;
  const composeEnhancers =
    (typeof window !== "undefined" &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const reducer = combineReducers({
    content: contentReducer.reducer,
    trendingState: trendingReducer,
    search: searchReducer,
    share: shareReducer,
    form: formReducer // mounted under "form"
  });

  const referralLink = referralCode ? `?referralcode=${referralCode}` : "";

  return createStore(
    reducer,
    { content: { ...contentReducer.initialState, referralLink, widget } },
    composeEnhancers(applyMiddleware(thunk))
  );
};

export default create;
